export default {"src":"/_next/static/media/ic-logo.4414ae5f.svg","height":45,"width":115,"blurWidth":0,"blurHeight":0};